  import { TimestampFormatPipe } from './../commons/timestampFormatPipe';
  import { MatSnackBar } from '@angular/material/snack-bar';
  import { Router } from '@angular/router';
  import { DateAdapter } from '@angular/material/core';
  import { NavigatorService } from './../services/navigator.service';
  import { Component, OnInit, OnDestroy } from '@angular/core';
  import { ComponentCacheService } from '../services/component-cache.service';
  import { ResponseQueryByCriteria } from '../shared/dto/responseQueryByCriteria';
  import { GenericListComponent } from '../shared/GenericListCoumponent';
import { DeviceTypeService } from '../services/device-aziendali/device-type.service';
import { DeviceTypeDTO } from '../shared/dto/device-aziendali/deviceType';
  
  @Component({
    selector: 'app-location',
    templateUrl: './deviceType.component.html',
    styleUrls: ['./deviceType.component.scss']
  })

  export class DeviceTypeComponent extends GenericListComponent implements OnInit, OnDestroy {
  
    constructor(
      private deviceTypeService: DeviceTypeService,
      componentCacheService: ComponentCacheService,
      navigatorService: NavigatorService,
      dateAdapter: DateAdapter<Date>,
      router: Router,
      snackBar: MatSnackBar,
      timestampFormatPipe: TimestampFormatPipe
    ) {
      super(
        navigatorService,
        componentCacheService,
        dateAdapter,
        router,
        snackBar,
        timestampFormatPipe);
      this.displayedColumns = ['id', 'descrizione', 'detail'];
      this.parameters = {
        dataSource: [],
        showList: false,
        filter: null,
        sortField: null,
        sortDirection: null,
        pageNumber: 0,
        pageSize: 50,
        length: 0
      } 
    }
  
    list() {
      this.deviceTypeService.typeList(
        this.parameters.pageNumber,
        this.parameters.pageSize,
        this.parameters.sortDirection,
        this.parameters.sortField,
        this.parameters.filter).subscribe(
          (res: ResponseQueryByCriteria<DeviceTypeDTO>) => {
            console.log("response : " + res);
            this.parameters.dataSource = res.content;
            this.parameters.pageNumber = res.pageNumber;
            this.parameters.length = res.totalElements;
            this.parameters.showList = true;
          }
        )
    }
  
    ngOnInit() {
      super.ngOnInit();
    }
  
    ngOnDestroy(): void {
      super.ngOnDestroy();
    }
  }
  